import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import DatatableComponent from "../../helpers/DatatableComponent";
import React, { useEffect, useState } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import moment from "moment";

import { Box, Card, Dialog, DialogContent, Tab, Tabs } from "@mui/material";
import OpenDocument from "../../helpers/openDocument";
import { getFileMime } from "../../store/helpers/common_functions";
import a11yProps from "../../helpers/ay-props";
import BootstrapDialogTitle from "../../helpers/BootstrapDialogTitle";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import TabBoxComponent from "components/UI/TabBox";
import { getFilteredTabs } from "./DocumentTabManagement";

function DocumentView({ systemSettings }) {
  const mainBackground = systemSettings?.mainBackground;

  const [count, setCount] = useState(0);
  const [description, setDescription] = useState();
  const [list, setList] = React.useState([]);
  const [fileView, setFileView] = useState(null);
  const [openView, setOpenView] = useState(false);
  const [certificateTab, setCertificateTab] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [id, setId] = useState();
  const [open, setOpen] = useState(0);
  const [value, setValue] = React.useState(0);
  const [formOpen, setFormOpen] = useState(false); // State to control form dialog
  const [selectedTab, setSelectedTab] = useState(0); // Add missing selectedTab state
  const [formData, setFormData] = useState({
    category: "",
    subcategory: "",
    fields: {},
  });

  const filteredTabList = getFilteredTabs(systemSettings?.permissions);

  useEffect(() => {
    if (filteredTabList.length > 0) {
      setValue(filteredTabList[0].tabValue);
      setSelectedTab(filteredTabList[0].tabValue);
    }
  }, [systemSettings?.permissions]);

  useEffect(() => {}, [systemSettings?.permissions]);

  const hasTabPermission = (tabIndex) => {
    const tab = filteredTabList.find((tab) => tab.tabValue === tabIndex);
    if (!tab?.permissionCode) return true;

    const userPermissions = systemSettings?.permissions || [];

    if (!tab.permissionCode) return true;

    if (userPermissions && userPermissions.length > 0) {
      return userPermissions.includes(tab.permissionCode);
    }

    return true;
  };

  const handleView = (id) => {
    const obj = list.find((x) => x.id === id);
    if (obj) {
      setFileView(obj?.attachment);
      setOpenView(true);
      setDescription(obj?.name);
    }
  };

  const handleEdit = (id) => {
    if (!Array.isArray(list)) {
      return;
    }

    const obj = list.find((x) => x.id === id);
    if (obj) {
      setId(id);
      const currentType = filteredTabList[selectedTab];

      setFormData({
        category: currentType.value,
        subcategory: currentType.subcategories?.[0]?.value || "",
        fields: {
          name: obj.name || "",
          title: obj.title || "",
          date: obj.date ? moment(obj.date).format("YYYY-MM-DD") : "",
          startDate: obj.startDate
            ? moment(obj.startDate).format("YYYY-MM-DD")
            : "",
          endDate: obj.endDate ? moment(obj.endDate).format("YYYY-MM-DD") : "",
          description: obj.description || "",
          attachment: obj.attachment || [],
          partner: obj.partner !== undefined ? obj.partner : "",
          ...obj.fields,
        },
      });

      setOpen(2);
      setFormOpen(true);
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setValue(newValue);
    const selectedType = filteredTabList.find(
      (tab) => tab.tabValue === newValue
    );
    if (selectedType) {
      setFormData({
        category: selectedType.value,
        subcategory: selectedType.subcategories?.[0]?.value || "",
        fields: {},
      });
      fetchData(selectedType.value, selectedType.subcategories?.[0]?.value);
    }
  };

  const getCurrentDocumentType = () => {
    const currentTab = filteredTabList.find(
      (tab) => tab.tabValue === selectedTab
    );
    return currentTab?.value || null;
  };
  const getCurrentSubcategory = () => {
    const currentTab = filteredTabList.find(
      (tab) => tab.tabValue === selectedTab
    );
    return currentTab?.subcategories?.[certificateTab]?.value || null;
  };

  useEffect(() => {
    if (["policies", "planning", "report"].includes(types[value]?.value)) {
      fetchData();
    }
  }, [certificateTab, value]);

  const types = [
    { label: "Institution Memory", value: "institution-memory" },
    { label: "MOUs", value: "mous" },
    { label: "Contracts", value: "contracts" },
    { label: "Publications", value: "publications" },
    { label: "Manuals", value: "manuals" },
    { label: "Policies", value: "policies" },
    { label: "Planning", value: "planning" },
    { label: "Templates", value: "templates" },
    { label: "Report", value: "report" },
    { label: "Others", value: "others" },
  ];

  const subcategories = {
    policies: [
      { label: "Internal Rules", value: "internal-rules" },
      { label: "Laws", value: "laws" },
      { label: "SOPs", value: "sops" },
      { label: " quarterly", value: "quotaly" },
    ],
    planning: [
      { label: "Strategic Plan", value: "strategic-plan" },
      { label: "Action Plan", value: "action-plan" },
      { label: "Budgets", value: "budgets" },
      { label: "M&E Matrics", value: "me-matrics" },
      { label: "Procurement", value: "procurement" },
    ],
    report: [
      { label: "Audit", value: "audit" },
      { label: "Financial", value: "financial" },
      { label: "Annual", value: "annual" },
      { label: " quarterly", value: "quotaly" },
    ],
  };

  const reportSubcategoryColumns = [
    { name: "title", label: "Title", required: true },
    { name: "date", label: "Date", type: "date" },
    {
      name: "attachment",
      label: "Attachment",
      type: "file-drag",
      multiple: true,
      accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
      required: true,
      value: value["termsOfReference"],
      options: {
        customBodyRender: (attachments) => (
          <div>
            {attachments && attachments.length > 0 ? (
              <i
                className="fas fa-paperclip"
                style={{ fontSize: "1.2rem" }}
              ></i>
            ) : (
              ""
            )}
          </div>
        ),
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id) => (
          <div className="flex items-center">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleView(id);
              }}
            >
              <img
                src={require("../../assets/icons/eye.svg").default}
                alt="View"
                className="mr-2 text-sm text-blueGray-300"
              />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(id);
              }}
            >
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Edit"
                className="mr-2 text-sm"
              />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setId(id);
                setDeleteOpen(true);
              }}
            >
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Delete"
                className="mr-2 text-sm"
              />
            </IconButton>
          </div>
        ),
      },
    },
  ];

  const columnsByType = {
    "institution-memory": [
      { name: "name", label: "Name", required: true },
      {
        name: "date",
        label: "Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },
      {
        name: "description",
        label: "Description",
        type: "textarea",
        options: {
          customBodyRender: (value) => (
            <Tooltip title={value || ""} arrow>
              <span>
                {value && value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value || ""}
              </span>
            </Tooltip>
          ),
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true,
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    mous: [
      { name: "name", label: "MOU Name", required: true },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },

      { name: "partner", label: "Partner" },
      {
        name: "daysRemaining",
        label: "Days Remaining",
        options: {
          customBodyRender: (value, tableMeta) => {
            const endDate = tableMeta.rowData[3];
            if (!endDate) return "";

            const end = moment(endDate, "YYYY-MM-DD");
            const today = moment().startOf("day");

            const daysRemaining = end.diff(today, "days");
            return daysRemaining >= 0 ? `${daysRemaining} days` : "Expired";
          },
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true,
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    contracts: [
      { name: "name", label: "Name" },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },

      { name: "partner", label: "Partner" },
      {
        name: "daysRemaining",
        label: "Days Remaining",
        options: {
          customBodyRender: (value, tableMeta) => {
            const endDate = tableMeta.rowData[3];
            const daysRemaining = moment(endDate).diff(moment(), "days");
            return daysRemaining >= 0 ? `${daysRemaining} days` : "Expired";
          },
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true,
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    publications: [
      { name: "name", label: "Title", required: true },
      {
        name: "publicationDate",
        label: "Publication Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },

      {
        name: "description",
        label: "Description",
        type: "textarea",
        options: {
          customBodyRender: (value) => (
            <Tooltip title={value || ""} arrow>
              <span>
                {value && value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value || ""}
              </span>
            </Tooltip>
          ),
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    manuals: [
      { name: "name", label: "Title", required: true }, // Mark as required
      {
        name: "date",
        label: "Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },

      {
        name: "description",
        label: "Description",
        type: "textarea", // Updated to textarea type
        options: {
          customBodyRender: (value) => (
            <Tooltip title={value || ""} arrow>
              <span>
                {value && value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value || ""}
              </span>
            </Tooltip>
          ),
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    policies: [
      { name: "name", label: "Title" },
      {
        name: "description",
        label: "Description",
        type: "textarea", // Updated to textarea type
        options: {
          customBodyRender: (value) => (
            <Tooltip title={value || ""} arrow>
              <span>
                {value && value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value || ""}
              </span>
            </Tooltip>
          ),
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],

    planning: [
      { name: "name", label: "Title" },
      {
        name: "description",
        label: "Description",
        type: "textarea", // Updated to textarea type
        options: {
          customBodyRender: (value) => (
            <Tooltip title={value || ""} arrow>
              <span>
                {value && value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value || ""}
              </span>
            </Tooltip>
          ),
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],

    report: [
      { name: "name", label: "Title", required: true }, // Mark as required
      {
        name: "date",
        label: "Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],

    templates: [
      { name: "name", label: "Name" },
      {
        name: "description",
        label: "Description",
        type: "textarea", // Updated to textarea type
        options: {
          customBodyRender: (value) => (
            <Tooltip title={value || ""} arrow>
              <span>
                {value && value.length > 50
                  ? `${value.substring(0, 50)}...`
                  : value || ""}
              </span>
            </Tooltip>
          ),
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],

    others: [
      { name: "name", label: "Name" },
      {
        name: "date",
        label: "Date",
        type: "date",
        options: {
          customBodyRender: (value) =>
            value && moment(value).isValid()
              ? moment(value).format("YYYY-MM-DD")
              : "-",
        },
      },
      {
        name: "attachment",
        label: "Attachment",
        type: "file-drag",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
        required: true, // Mark attachment as required
        value: value["termsOfReference"],
        options: {
          customBodyRender: (attachments) => (
            <div>
              {attachments && attachments.length > 0 ? (
                <i
                  className="fas fa-paperclip"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              ) : (
                ""
              )}
            </div>
          ),
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => (
            <div className="flex items-center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleView(id);
                }}
              >
                <img
                  src={require("../../assets/icons/eye.svg").default}
                  alt="View"
                  className="mr-2 text-sm text-blueGray-300"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(id);
                }}
              >
                <img
                  src={require("../../assets/icons/pencil.svg").default}
                  alt="Edit"
                  className="mr-2 text-sm"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setId(id);
                  setDeleteOpen(true);
                }}
              >
                <img
                  src={require("../../assets/icons/trash.svg").default}
                  alt="Delete"
                  className="mr-2 text-sm"
                />
              </IconButton>
            </div>
          ),
        },
      },
    ],
  };

  const getColumns = () => {
    const documentType = getCurrentDocumentType();

    if (!documentType) {
      return [];
    }

    if (columnsByType[documentType]) {
      return columnsByType[documentType];
    }

    const currentMainType = types[value]?.value;
    if (currentMainType === "report") {
      return reportSubcategoryColumns;
    }

    return columnsByType["institution-memory"] || [];
  };

  const columns = getColumns();

  const handleAddNew = () => {
    const currentCategory = types[value]?.value;
    const currentSubcategory =
      subcategories[currentCategory]?.[certificateTab]?.value || "";

    setFormData({
      category: currentCategory,
      subcategory: currentSubcategory,
      fields: {
        startDate: "",
        endDate: "",
      },
    });

    setFormOpen(true);
    setOpen(1);
  };

  const getFormFields = () => {
    const category = formData.category;
    const subcategory = formData.subcategory;

    const baseFields = [];

    if (open === 1) {
      baseFields.push({
        name: "category",
        label: "Category",
        type: "select",
        value: category,
        values: types.map((type) => ({ label: type.label, value: type.value })),
        required: true,
        disabled: true,
      });

      if (category && subcategories[category]) {
        baseFields.push({
          name: "subcategory",
          label: "Subcategory",
          type: "select",
          value: subcategory,
          values:
            subcategories[category]?.map((sub) => ({
              label: sub.label,
              value: sub.value,
            })) || [],
          required: true,
          disabled: true,
        });
      }
    }

    let currentColumns = columnsByType[category] || [];
    if (category === "report") {
      currentColumns = reportSubcategoryColumns;
    }

    const dynamicFields = currentColumns
      .filter(
        (column) => column.name !== "daysRemaining" && column.name !== "id"
      )
      .map((column) => ({
        name: column.name,
        label: column.label,
        type: column.type || "text",
        value:
          column.type === "date"
            ? moment(formData.fields[column.name]).format("YYYY-MM-DD") || ""
            : formData.fields[column.name] || "",
        required: column.required || false,
        setValue: (val) =>
          setFormData((prev) => ({
            ...prev,
            fields: { ...prev.fields, [column.name]: val },
          })),
      }));

    const attachmentIndex = dynamicFields.findIndex(
      (f) => f.name === "attachment"
    );
    if (attachmentIndex > -1) {
      const [attachment] = dynamicFields.splice(attachmentIndex, 1);
      dynamicFields.push(attachment);
    }

    return [...baseFields, ...dynamicFields];
  };

  const handleFormSuccess = (newData) => {
    setFormOpen(false);
    setCount((v) => v + 1);
  };

  const fetchData = (type, subcategory) => {
    const currentType = type || getCurrentDocumentType();
    if (!currentType) {
      return;
    }

    let url = `/api/manuals/list?type=${encodeURIComponent(currentType)}`;

    const currentTab = filteredTabList.find((tab) => tab.value === currentType);
    if (subcategory || (currentTab && currentTab.subcategories)) {
      const subcat =
        subcategory || currentTab.subcategories[certificateTab]?.value || "";
      url += `&subcategory=${encodeURIComponent(subcat)}`;
    }

    url += `&_=${new Date().getTime()}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setList(data.data);
        } else {
          setList([]);
        }
      })
      .catch((error) => {
        setList([]);
      });
  };

  const handleFormSubmit = (formValues) => {
    const submitData = new FormData();

    const { category, subcategory, ...fields } = formValues || {};

    const body = {
      category,
      subcategory: subcategory || "",
      ...fields,
    };

    submitData.append("body", JSON.stringify(body));

    if (fields.attachment) {
      if (Array.isArray(fields.attachment)) {
        fields.attachment.forEach((file) => {
          if (file instanceof File) submitData.append("attachment", file);
        });
      } else if (fields.attachment instanceof File) {
        submitData.append("attachment", fields.attachment);
      }
    }

    return fetch(
      open === 1 ? "/api/manuals/create" : `/api/manuals/update/${id}`,
      {
        method: "POST",
        body: submitData,
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setFormOpen(false);
        setCount((prev) => prev + 1);
        fetchData();
        return data;
      })
      .catch((error) => {});
  };

  const getUrl = (type, subcategory) => {
    const currentType = type || getCurrentDocumentType();
    if (!currentType) return "";

    let url = `/api/manuals/list?type=${encodeURIComponent(currentType)}`;

    if (subcategory) {
      url += `&subcategory=${encodeURIComponent(subcategory)}`;
    }

    url += `&count=${count}`;

    return url;
  };

  return (
    <div>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={openView}
        onClose={() => setOpenView(false)}
      >
        <BootstrapDialogTitle onClose={() => setOpenView(false)}>
          Document Details
        </BootstrapDialogTitle>
        <DialogContent>
          Name: {description} {/* Updated to display the name */}
          {fileView !== null && (
            <OpenDocument
              downloadable={true}
              document={fileView}
              name={"supportDocument"}
              specialName={fileView}
              type={"permission-doc"}
              mimeType={getFileMime(fileView)}
            />
          )}
        </DialogContent>
      </Dialog>

      <FormDialog
        open={formOpen}
        setOpen={setFormOpen}
        onSuccess={(newData) => handleFormSuccess(newData)}
        url={open === 1 ? "/api/manuals/create" : `/api/manuals/update/${id}`}
        fields={getFormFields()}
        title={
          open === 1
            ? `Add New ${getCurrentDocumentType()}`
            : `Edit ${getCurrentDocumentType()}`
        }
        onSubmit={handleFormSubmit}
      />

      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={() => setCount((v) => v + 1)}
        url={`/api/manuals/delete/${id}`}
      />

      <Card>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTabs-root": {
              minHeight: "48px",
            },
            "& .MuiTabs-scroller": {
              overflowX: "auto !important",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                height: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "3px",
              },
            },
          }}
        >
          {filteredTabList && filteredTabList.length > 0 ? (
            <TabBoxComponent
              selectedValue={selectedTab}
              handleTabChange={handleTabChange}
              tabList={filteredTabList}
              sx={{
                maxWidth: "100%",
                "& .MuiTabs-flexContainer": {
                  flexWrap: "nowrap",
                },
              }}
              variant="scrollable"
              scrollButtons="auto"
            />
          ) : (
            <Typography>No accessible tabs found</Typography>
          )}
        </Box>

        {hasTabPermission(selectedTab) && (
          <>
            {(() => {
              const currentTab = filteredTabList.find(
                (tab) => tab.tabValue === selectedTab
              );
              if (!currentTab) return null;

              return (
                <>
                  {currentTab.subcategories && (
                    <Box
                      sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
                    >
                      <Tabs
                        value={certificateTab}
                        onChange={(e, v) => setCertificateTab(v)}
                        aria-label="subcategory tabs"
                        TabIndicatorProps={{ style: { display: "none" } }}
                      >
                        {currentTab.subcategories.map((subcategory, index) => (
                          <Tab
                            key={subcategory.value}
                            label={<span>{subcategory.label}</span>}
                            {...a11yProps(index)}
                            sx={{
                              backgroundColor:
                                certificateTab === index
                                  ? mainBackground
                                  : "transparent",
                              color:
                                certificateTab === index ? "#fff" : "inherit",
                              borderRadius: "8px",
                              "&.Mui-selected": {
                                color: "#fff",
                              },
                            }}
                          />
                        ))}
                      </Tabs>
                    </Box>
                  )}

                  <DatatableComponent
                    viewColumns={false}
                    search={false}
                    onAddNew={handleAddNew}
                    searchfield={true}
                    processData={(data) => {
                      const dataArray = Array.isArray(data) ? data : data.data;
                      setList(dataArray?.data);
                      return dataArray;
                    }}
                    elevation={0}
                    columns={columns}
                    url={getUrl(
                      currentTab.value,
                      currentTab.subcategories?.[certificateTab]?.value
                    )}
                    onRowClick={(rowData, { rowIndex }) => {
                      const selectedRow = list[rowIndex];
                      if (selectedRow) {
                        handleView(selectedRow.id);
                      }
                    }}
                  />
                </>
              );
            })()}
          </>
        )}
      </Card>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentView);
